import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { scrollToId } from "../lib/ui";

const LINES = ["Livets store", "beslutninger er svære nok.", "Det juridiske behøver ikke at være"];

const ease = [0.22, 1, 0.36, 1];

export const Hero = () => {
  const navigate = useNavigate();

  return (
  <section id="top" className="relative overflow-hidden">
    <div className="absolute inset-0" aria-hidden="true">
      <img
        src="https://images.unsplash.com/photo-1541194577687-8c63bf9e7ee3?crop=entropy&cs=srgb&fm=jpg&q=80"
        alt=""
        className="h-full w-full object-cover object-center"
        loading="eager"
      />
      <div className="absolute inset-0 bg-brand-950/60" />
      <div className="absolute inset-x-0 bottom-0 h-32 bg-gradient-to-t from-brand-950/70 to-transparent" />
    </div>

    <div className="relative mx-auto max-w-[1440px] px-4 pb-24 pt-40 sm:px-6 sm:pt-52 lg:px-8 lg:pb-36 lg:pt-60">
      <h1
        data-testid="hero-heading"
        className="max-w-4xl text-[2.5rem] font-semibold leading-[1.08] tracking-[-0.02em] text-white sm:text-6xl lg:text-[4.5rem]"
      >
        {LINES.map((line, i) => (
          <span key={i} className="-mb-[0.12em] block overflow-hidden pb-[0.12em]">
            <motion.span
              className="block"
              initial={{ y: "112%" }}
              animate={{ y: 0 }}
              transition={{ duration: 0.95, delay: 0.15 + i * 0.13, ease }}
            >
              {i === LINES.length - 1 ? (
                <>
                  {line}
                  <span className="text-brand-400">.</span>
                </>
              ) : (
                line
              )}
            </motion.span>
          </span>
        ))}
      </h1>

      <motion.p
        initial={{ opacity: 0, y: 18 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, delay: 0.6, ease }}
        className="mt-6 max-w-xl text-base leading-relaxed text-white/75 sm:text-lg"
      >
        Fortæl os kort, hvad din sag handler om. Juris hjælper dig med at skabe overblik
        og finde den rette vej videre — som privatperson eller virksomhed.
      </motion.p>

      <motion.div
        initial={{ opacity: 0, y: 18 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, delay: 0.72, ease }}
        className="mt-10 flex flex-col items-start gap-4 sm:flex-row sm:items-center"
      >
        <button
          data-testid="hero-primary-cta"
          onClick={() => navigate("/kontakt")}
          className="group inline-flex items-center gap-4 rounded-full bg-brand-950 py-3 pl-8 pr-3 text-base font-semibold text-white shadow-xl shadow-black/30 ring-1 ring-white/25 transition-all duration-200 hover:bg-brand-900"
        >
          Fortæl os om din sag
          <span className="flex h-10 w-10 items-center justify-center rounded-full bg-white text-brand-600 transition-transform duration-200 group-hover:rotate-[-45deg]">
            <ArrowRight className="h-4 w-4" strokeWidth={2.2} />
          </span>
        </button>
        <button
          data-testid="hero-secondary-cta"
          onClick={() => scrollToId("omraeder")}
          className="group inline-flex items-center gap-2 px-3 py-3 text-base font-semibold text-white transition-colors hover:text-brand-300"
        >
          Se hvad vi hjælper med
          <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" />
        </button>
      </motion.div>
    </div>
  </section>
  );
};

export default Hero;